var _desc, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    className: "circular-loader",
    viewBox: "22 22 44 44",
    overflow: "visible",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "loader"
  }, "Loading")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "primary-stroke",
    cx: 44,
    cy: 44,
    r: 20.2,
    fill: "none",
    stroke: "#70c542",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.de181466e27addfcc8ab86d6d3b4116a.svg";
export { ForwardRef as ReactComponent };